import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Icon } from '@swift-paypal/pp-react-icons';
import { useTheme } from '@swift-paypal/pp-react-theme';
import { Shimmer } from '@swift-paypal/pp-react-utils';
import '../__generated__/styles/icon-button.css';

var styles = {"ppvx_icon-button":"ppvx_icon-button___1-4-7","ppvx_icon-button--primary":"ppvx_icon-button--primary___1-4-7","ppvx_icon-button--inverse":"ppvx_icon-button--inverse___1-4-7","ppvx_icon-button--size_sm":"ppvx_icon-button--size_sm___1-4-7","ppvx_icon-button--secondary":"ppvx_icon-button--secondary___1-4-7","ppvx_icon-button--tertiary":"ppvx_icon-button--tertiary___1-4-7","ppvx_icon-button__label":"ppvx_icon-button__label___1-4-7","ppvx_icon-button__icon":"ppvx_icon-button__icon___1-4-7","ppvx_icon-button__shimmer":"ppvx_icon-button__shimmer___1-4-7","ppvx--v2":"ppvx--v2___1-4-7","ppvx--v1":"ppvx--v1___1-4-7"};

var IconButton = forwardRef(function (props, ref) {
  var _clsx;

  var as = props.as,
      iconName = props.iconName,
      svgIconComponent = props.svgIconComponent,
      className = props.className,
      iconClassName = props.iconClassName,
      children = props.children,
      _props$buttonType = props.buttonType,
      buttonType = _props$buttonType === void 0 ? 'primary' : _props$buttonType,
      inverse = props.inverse,
      size = props.size,
      theme = props.theme,
      isLoading = props.isLoading,
      rest = _objectWithoutProperties(props, ["as", "iconName", "svgIconComponent", "className", "iconClassName", "children", "buttonType", "inverse", "size", "theme", "isLoading"]); // If theme is not directly provided, get from themeContext


  var _theme = useTheme('IconButton', theme);

  var isV2 = _theme && _theme === 'v2';

  if (isV2 && isLoading) {
    var _cls = clsx(styles['ppvx_icon-button__shimmer'], size && styles["ppvx_icon-button--size_".concat(size)], className);

    return /*#__PURE__*/React.createElement(Shimmer, {
      className: _cls,
      isInverse: inverse,
      hasStyleDefaults: false
    }, children);
  }

  var cls = clsx(styles['ppvx_icon-button'], styles["ppvx_icon-button--".concat(buttonType)], (_clsx = {}, _defineProperty(_clsx, styles['ppvx_icon-button--inverse'], inverse), _defineProperty(_clsx, styles["ppvx_icon-button--size_".concat(size)], size), _clsx), isV2 && styles['ppvx--v2'], className);
  var Component = as || 'button'; // Setting type to null will not add the attribute:

  var type = Component === 'button' ? 'button' : null;
  var iconClasses = clsx(styles['ppvx_icon-button__icon'], iconClassName);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cls,
    ref: ref,
    type: type
  }, rest), /*#__PURE__*/React.createElement(svgIconComponent || Icon, {
    className: iconClasses,
    name: iconName,
    size: "sm"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_icon-button__label']
  }, children)));
});

export { IconButton };
